export const StdinSymbol = Symbol('Stdin')
export const StdoutSymbol = Symbol('Stdout')
export const StderrSymbol = Symbol('Stderr')
export const AppSymbol = Symbol('App')
export const FocusSymbol = Symbol('Focus')

// Component context symbols
export const AccessibilitySymbol = Symbol('Accessibility')
export const BackgroundSymbol = Symbol('Background')
export const ThemeSymbol = Symbol('Theme')

// List component symbols
export const OrderedListSymbol = Symbol('OrderedList')
export const OrderedListItemSymbol = Symbol('OrderedListItem')
export const UnorderedListSymbol = Symbol('UnorderedList')
export const UnorderedListItemSymbol = Symbol('UnorderedListItem')
